import { render } from "./TestPlanTab.vue?vue&type=template&id=07745ae6&scoped=true"
import script from "./TestPlanTab.vue?vue&type=script&lang=js"
export * from "./TestPlanTab.vue?vue&type=script&lang=js"

import "./TestPlanTab.vue?vue&type=style&index=0&id=07745ae6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07745ae6"]])

export default __exports__